<template>
  <div class="page">
    <div class="page-padding">
      <figure class="visual">
        <picture>
          <source media="(min-width: 550px)" srcset="img/visual-modelleisenbahn.jpg">
          <img src="img/visual-modelleisenbahn-small.jpg"/>
        </picture>
        <figcaption>
          <h1>Modelleisenbahn</h1>
        </figcaption>
      </figure>
      <h2 class="carousel-headline">Unsere Filme zum Thema Modelleisenbahn</h2>
      <modelleisenbahn-movies-list></modelleisenbahn-movies-list>
    </div>
  </div>
</template>

<script>

import ModelleisenbahnMoviesList from './ModelleisenbahnMoviesList.vue';

export default {
  components: {
    modelleisenbahnMoviesList: ModelleisenbahnMoviesList
  },
  beforeRouteEnter(to, from, next) {
    window.scrollToTop();
    next();
  },
}
</script>



// WEBPACK FOOTER //
// Modelleisenbahn.vue?38a65162